export const hydrateIdAttribute = 'data-ts-hydrate-id'
export const hydrateWhenAttribute = 'data-ts-hydrate-when'
export const hydrateInteractionEventsAttribute =
  'data-ts-hydrate-interaction-events'
